<template>
  <div class="land-button-box">
    <!-- 表格数据 -->
    <div class="action-bar">
      <div>
        模版：
        <el-input size="small" clearable class="param-input" v-model="this.templet" disabled></el-input>
        <el-button type="primary" size="small" icon="el-icon-edit" @click="editTem()">编辑</el-button>
      </div>
      <el-divider></el-divider>按钮配置：
      <el-button type="primary" size="small" @click="action('add',{arr:tableData})">新增</el-button>
    </div>
    <el-table
      :data="tableData"
      border
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
    >
      <el-table-column prop=" name" label="名称" align="center" min-width="150">
        <template slot-scope="scope">{{scope.row.name || '未知'}}</template>
      </el-table-column>
      <el-table-column prop=" style" label="样式" align="center" min-width="150">
        <template slot-scope="scope">{{scope.row.style |styleList}}</template>
      </el-table-column>
      <el-table-column prop=" type" label="类型" align="center" min-width="150">
        <template slot-scope="scope">{{scope.row.type |typeList}}</template>
      </el-table-column>
      <el-table-column prop=" enable" label="显示按钮" align="center" min-width="150">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.enable" size="small" disabled></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" min-width="150">
        <template slot-scope="scope">
          <el-button
            type="success"
            size="mini"
            icon="el-icon-edit"
            @click="action('edit',{arr:tableData,index: scope.$index},)"
          ></el-button>
          <el-button type="danger" size="mini" icon="el-icon-delete" @click="remove(scope.$index)"></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--  编辑、添加按钮 -->
    <edit-page ref="editPage" @handlerSwitch="getLdyList"></edit-page>
    <!-- 编辑落地页模版 -->
    <edit-templet ref="editTemplet" @handlerSwitch="getLdyList"></edit-templet>
  </div>
</template>
<script>
import EditPage from "./components/editPage";
import EditTemplet from "./components/editTemplet";
import api from "@/api";
export default {
  data() {
    return {
      loading: false,
      tableData: [],
      id: "",
      templet: "",
      params: {},
      index: ""
    };
  },
  components: {
    EditPage,
    EditTemplet
  },
  created() {
    this.getLdyList();
  },
  methods: {
    // 获取列表
    getLdyList() {
      api.getLdyList(this.params).then(res => {
        this.templet = res.data.templet;
        this.id = res.data.id;
        if (res.code === 200 && res.data.buttons.length > 0) {
          this.tableData = res.data.buttons;
        }
      });
    },
    remove(index) {
      this.tableData.splice(index, 1);
      let param = {
        buttons: this.tableData,
        id: this.id,
        template: this.templet
      };
      api.updateLdy(param).then(res => {
        if (res.code === 200) {
          this.$message({
            message: "删除成功",
            type: "success"
          });
          this.getLdyList();
        } else {
          this.$message.error("删除失败,请重试");
        }
        this.handleClose();
        this.flag = false;
      });
    },
    action(type, buttons) {
      let param = Object.assign({}, buttons, {
        id: this.id,
        templet: this.templet
      });
      this.$refs.editPage.open(type, param);
    },
    editTem() {
      let param = Object.assign(
        {},
        {
          buttons: this.tableData,
          id: this.id,
          templet: this.templet
        }
      );
      this.$refs.editTemplet.open(param);
    }
  }
};
</script>